const consulta_de_vagas_por_escolas = {
  path: "/consulta-vagas-por-escola",
  redirect: "/consulta-vagas-por-escola",
  meta: {
    breadCrumb: "Consulta de Vagas - Consulta Por Escolas",
  },
  children: [
    {
      path: "/consulta-vagas-por-escola",
      name: "consulta-vagas-por-escola",
      meta: {
        allowedPermissions: ["consulta_de_vagas_por_escola"],
      },
      component: () =>
        import(
          "@/views/ConsultaDeVagasPorEscola/ConsultaDeVagasPorEscolaHome.vue"
        ),
    },
  ],
};

export { consulta_de_vagas_por_escolas };
